import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterRoutingModule } from './footer-routing.module';
import { FooterComponent } from './footer.component';
import { FormsModule } from '@angular/forms';
import { ShareModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    CommonModule,
    FooterRoutingModule,
    ShareModule
  ],
  exports : [FooterComponent]
})
export class FooterModule { }
